import templateStr from 'text!./templates/bank-account-details.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,

        scope: {
            bankAccountDetails: '=gwPlBankAccountDetails'
        },

        controller: ['$scope', function (scope) {
            scope.bankAccountDetails.value = scope.bankAccountDetails.value || {};
            scope.accTypes = scope.bankAccountDetails.bankAccountType.aspects.availableValues;
            scope.bankAccountDetails.bankAccountType.value = scope.bankAccountDetails.bankAccountType.value || scope.accTypes[0];
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/paymentdetails/BankAccountDetailsDirective.js
// module id = 1053
// module chunks = 0